import styled from 'styled-components'

export const Container = styled.div`
    form {
        display: grid !important;
        justify-items: center;
        align-items: center;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
            'declaracao valor'
            'check check'
            'button button';
            
        @media(max-width: 650px) {
            grid-template-columns: 1fr;
            grid-template-areas:
                'declaracao'
                'valor'
                'check'
                'button';
        }
    }
`
